import difference from 'lodash/difference'
import { pick } from 'lodash'
import { keysOfObject } from 'legacy/common/utils'
import {
  type EditImagesValues,
  PrimaryImageAngle,
  type SecondaryImageAngleMapping,
  SecondaryImageDefaults,
} from 'domains/products/components/edit-images/components/types/EditImageTypes.types'

function normalizeSecondaryImageAngles(secondaryImages: {
  [key: string]: string
}): SecondaryImageAngleMapping {
  const validAngles = keysOfObject(SecondaryImageDefaults)

  return pick(secondaryImages, validAngles)
}

function selectImageAngles(values: EditImagesValues) {
  return {
    [PrimaryImageAngle]: values.primaryImageUrl || undefined,
    ...normalizeSecondaryImageAngles(values.secondaryImages),
  }
}

export function selectInvalidImageAngles(original: EditImagesValues, next: EditImagesValues) {
  const originalImages = selectImageAngles(original)
  const nextImages = selectImageAngles(next)

  const presentImages = keysOfObject(nextImages).filter(angle => Boolean(nextImages[angle]))
  const updatedImages = presentImages.filter(angle => originalImages[angle] !== nextImages[angle])

  // It is invalid to be missing a primary image
  if (nextImages[PrimaryImageAngle] === undefined) {
    return [PrimaryImageAngle]
  }

  // If no present images were updated, then everything is ok
  if (updatedImages.length === 0) return []

  // Otherwise, we returns any stale images that were not updated
  return difference(presentImages, updatedImages)
}
